export const MAIN_CLASS_NAME = 'status-panel';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const SUCCESS_CLASS_NAME = `${CONTENT_CLASS_NAME}_success`;
export const ERROR_CLASS_NAME = `${CONTENT_CLASS_NAME}_error`;
export const ICON_CLASS_NAME = `${CONTENT_CLASS_NAME}__icon`;
export const HEADER_CLASS_NAME = `${CONTENT_CLASS_NAME}__header`;
export const DESCRIPTION_CLASS_NAME = `${CONTENT_CLASS_NAME}__description`;
